import request from '@src/util/request';
import HttpStatusCode from '@src/constants/HttpStatusCode';
import { Method } from 'axios';

const BASE = '/admin/card';

type ApiOk<T> = { code: number; message?: string; data: T };

async function callApi<T>(
  url: string,
  options?: { method?: Method; data?: any; params?: any }
): Promise<{ ok: boolean; data?: T; message?: string }> {
  const method = (options?.method || 'GET').toLowerCase() as Method;
  const qs =
    options?.params && method === 'get'
      ? `?${new URLSearchParams(
          Object.entries(options.params)
            .filter(([, v]) => v !== undefined && v !== null && v !== '')
            .map(([k, v]) => [k, String(v)])
        ).toString()}`
      : '';

  const res = await request<ApiOk<T>>({
    url: `${url}${qs}`,
    options: {
      method,
      data: options?.data,
    },
    noti: false,
  });

  if (!res || res.status !== HttpStatusCode.OK) {
    const msg =
      (res?.data as any)?.message ||
      (res?.data as any)?.issues?.[0]?.message ||
      'Request failed';
    return { ok: false, message: msg };
  }

  const body = res.data as any;
  if (body?.code !== 0 && body?.code !== undefined) {
    return { ok: false, message: body.message || 'error', data: body.data };
  }

  return { ok: true, data: body.data, message: body.message };
}

export type CustomerCardMapListParams = {
  customerId?: number;
  sourceType?: 'card' | 'cardCampaign';
  sourceId?: number;
  linkType?: string;
  isActive?: boolean;
  phone?: string;
  cardNumber?: string;
  skip?: number;
  limit?: number;
};

export type CustomerCardMapListResult = {
  total: number;
  rows: any[];
};

export const customerCardMapApi = {
  list: (params: CustomerCardMapListParams) =>
    callApi<CustomerCardMapListResult>(`${BASE}/customer-maps`, {
      method: 'GET',
      params: {
        ...params,
        isActive:
          params.isActive === undefined
            ? undefined
            : params.isActive
              ? 'true'
              : 'false',
      },
    }),

  setActive: (data: {
    id?: number;
    customerId?: number;
    sourceType?: 'card' | 'cardCampaign';
    sourceId?: number;
    isActive: boolean;
  }) =>
    callApi<any>(`${BASE}/set-customer-map-active`, {
      method: 'POST',
      data,
    }),

  pointLedgers: (params: {
    sourceType?: 'card' | 'cardCampaign';
    sourceId?: number;
    phone?: string;
    cardNumber?: string;
    reason?: string;
    direction?: 'credit' | 'debit';
    createdFrom?: string;
    createdTo?: string;
    refType?: string;
    refId?: number;
    skip?: number;
    limit?: number;
  }) =>
    callApi<{ total: number; rows: any[] }>(`${BASE}/point-ledgers`, {
      method: 'GET',
      params,
    }),
};

export default customerCardMapApi;
